import api from "../client.ts";

type ParentType = {
  id: number;
  personne_id: number;
  status: number;
  created_at: string; // ISO timestamp string
  updated_at: string; // ISO timestamp string
  nom: string;
  type:string
  email:string
  profession:string
  postnom: string;
  prenom: string;
  sexe: 'M' | 'F'; // assuming only 'M' or 'F' are valid
  adresse_id: number;
  telephone: string;
  ville: string;
  commune: string;
  quartier: string;
  avenue: string;
  parent_id: number;
};

type PromotionType = {
  id: number;
  eleve_id: number;
  classe_id: number;
  annee_scolaire_id: number;
  status: number;
  created_at: string;
  updated_at: string | null;
};
export type StudentType = {
  id: number;
  uid: string;
  personne_id: number;
  date_naissance: string;  // Format: YYYY-MM-DD
  lieu_naissance: string;
  path_img: string;
  parent_id: number;
  status: number;
  created_at: string;      // Format: YYYY-MM-DD HH:MM:SS
  updated_at: string;      // Format: YYYY-MM-DD HH:MM:SS
  nom: string;
  postnom: string;
  prenom: string;
  sexe: 'M' | 'F';         // Assuming gender is either 'M' or 'F'
  adresse_id: number;
  telephone: string;
  ville: string;
  commune: string;
  quartier: string;
  avenue: string;
  eleve_id: number;
  parentData:ParentType
  promotionData:PromotionType
  classeDesignation: string
  classeId:number
};

const getAll = async ():Promise<{size:number, data:StudentType[]}> => {
  const { data } = await api.get("/eleve/readAll");
  return data;
};

const create = async (newUser:any) => {
  const { data } = await api.post("/eleve/create", newUser);
  return data;
};
const update = async (id:any, newUser:any) => {
  const { data } = await api.put(`/eleve/update?id=${id}`, newUser);
  return data;
};
const desactivate = async (id:any) => {
  const { data } = await api.get(`/eleve/desactive?id=${id}`);
  return data;
};
const activate = async (id:any) => {
  const { data } = await api.get(`/eleve/active?id=${id}`);
  return data;
};
const deleteStudent = async (id:any) => {
  const { data } = await api.delete(`/eleve/${id}`);
  return data;
};
const archive = async (id:any) => {
  const { data } = await api.patch(`/eleve/${id}`);
  return data;
};

const createStudentAndParent = async (data:any)=>{
    const [studentResponse, parentResponse] = await Promise.all([
        api.post("/eleves", data.userData),
        api.post("/parents", data.parentData)
    ])

    return {
        student:studentResponse.data,
        parent:parentResponse.data
    }
}

export const studentControler = {getAll, create, update, deleteStudent, archive,activate,desactivate, createStudentAndParent}